import { useState } from "react";
import { Flex, Text, Button, SimpleGrid, Skeleton, Image, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { format } from "date-fns";
import { AgGridReact } from 'ag-grid-react'; 
import { tableTheme } from "../includes/theme";

import { Header, AddPersonModal, EditPersonModal } from "../includes";
import { useQuranPersons, useEditQuranPersonOrder } from "../hooks";

export default function Quran() {
	const [addPerson, setAddPerson] = useState(false);
	const [editPerson, setEditPerson] = useState();

	const { data } = useQuranPersons();
	return (
		<Flex direction="column" h={window.innerHeight}>
			<Header />
			<Flex direction="column" p="30px 40px" flex="1">
				<Flex align="center" justify="center" mb="10px">
					<Flex flex="1" direction="column">
						<Text mb="7px" variant="title">Khatmat Quran</Text>
					</Flex>
					<Button onClick={() => setAddPerson(true)} variant="primary" borderRadius="30px" fontSize="14px" p="12px 15px">Add person</Button>
				</Flex>
			    <Flex flex="1" borderRadius="10px" w="100%" direction="column" >
					<TableData data={data} onEdit={(e) => setEditPerson(e)} />
				</Flex>
			</Flex>
			{
				addPerson && <AddPersonModal total={data.length} onClose={() => setAddPerson(false)} />
			}
			{
				editPerson && <EditPersonModal data={editPerson} onClose={() => setEditPerson()} />
			}
		</Flex>
	)
}

function TableData({ data, onEdit }) {
	const columns = [
        { 
        	field: "id", 
        	headerName: "ID",
        	flex:1,
        	cellStyle: { border: "none" }
        },
        { 
        	field: "name.english", 
        	headerName: "Title", 
        	filter: true,
        	flex:3,
        	cellStyle: { border: "none" },
        	cellRenderer: ({ data }) => {
        		return (
					<Flex h="100%" align="center">
						<Image
							src={data.image}
							alt="Image"
							w="35px"
							h="35px"
							borderRadius="30px"
							objectFit="cover"
							flexShrink={0}
							mr="7px"
						/>
						<Text pl="13px" fontWeight="500" fontSize="15px">{data.name['english'] || data.name['arabic'] || data.name['persian']}</Text>
					</Flex>
        		)
        	}
        },
        { 
        	field: "createdBy", 
        	flex:1,
        	cellStyle: { border: "none" },
        	headerName: "Created By"
        },
        { 
        	field: "updatedAt", 
        	headerName: "Updated On",
        	flex:1,
        	cellStyle: { border: "none" },
        	cellRenderer: ({ data }) => {
        		return format(data.updatedAt, 'MMM dd, yyyy')
        	}
        },
        { 
        	field: "updatedAt", 
        	headerName: "Live On",
        	filter: true,
        	flex:1,
        	cellStyle: { border: "none" },
        	cellRenderer: ({ data }) => {
        		return data.liveOn ? format(data.liveOn, 'MMM dd, yyyy') : ""
        	}
        },
        { 
        	field: "type", 
        	flex:1,
        	filter: true,
        	cellStyle: { border: "none" },
        },
        { 
        	field: "totalKhatmat", 
        	flex:1,
        	filter: true,
        	cellStyle: { border: "none" },
        },
        { 
        	field: "status", 
        	cellStyle: { border: "none" },
        	filter: true,
        	flex: 1,
        	cellRenderer: ({ data }) => {
        		return (
					<Flex  h="100%" align="center">
						<Text color={data.status == "live" || data.status == "finished" ? "success" : data.status == "pending" || data.status == "not-live" ? "warning" : data.status == "rejected" ? "error" : "primary"} fontWeight="400" fontSize="15px">{data.status}</Text>
					</Flex>
        		)
        	}
        },
        { 
        	field: "button", 
        	headerName:"",
        	cellStyle: { border: "none" },
        	flex: 1,
        	cellRenderer: ({ data }) => {
        		return (
					<Flex h="100%" direction="column" justify="center" align="center">
						<Button onClick={() => onEdit(data)} variant="white">Edit</Button>
					</Flex>
        		)
        	}
        }
	]

	return (
	    <AgGridReact
	        rowData={data}
	        theme={tableTheme}
	        columnDefs={columns}
	        pagination
	    />
	)
}







